import { combineReducers } from '@reduxjs/toolkit';

import { reducer as visitsReducer } from './visits/visits.redux';
import { reducer as reportsReducer } from './reports/reports.redux';
import { reducer as patientsReducer } from './patients/patients.redux';
import { reducer as consultationsQueueReducer } from './consultationsQueue/consultationsQueue.redux';
import { reducer as practitionersReducer } from './practitioners/practitioners.redux';
import { reducer as ordersReducer } from './orders/orders.redux';
import { reducer as transactionsReducer } from './transactions/transactions.redux';
import { reducer as statesReducer } from './states/states.redux';
import { reducer as settingsReducer } from './settings/settings.redux';
import { reducer as productVariationsReducer } from './productVariations/productVariations.redux';
import { reducer as productsReducer } from './products/products.redux';
import { reducer as projectsReducer } from './projects/projects.redux';
import { reducer as authReducer } from './auth/auth.redux';
import { reducer as affiliateAdminsReducer } from './affiliateAdmins/affiliateAdmins.redux';
import { reducer as webhooksReducer } from './webhooks/webhooks.redux';
import { reducer as questionnairesReducer } from './questionnaires/questionnaires.redux';
import { reducer as pharmaciesReducer } from './pharmacies/pharmacies.redux';
import { reducer as communicationTemplatesReducer } from './communicationTemplates/communicationTemplates.redux';
import { reducer as labOrdersReducer } from './labOrders/labOrders.redux';
import { reducer as labPanelsReducer } from './labPanels/labPanels.redux';
import { reducer as labsReducer } from './labs/labs.redux';
import { reducer as noteTemplatesReducer } from './noteTemplates/noteTemplates.redux';
import { reducer as chatReducer } from './chat/chat.redux';
import { reducer as suppliesReducer } from './supplies/supplies.redux';
import { reducer as tagsReducer } from './tags/tags.redux';
import { reducer as journeyTemplateReducer } from './journeyTemplate/journeyTemplate.redux';
import { reducer as productReducer } from './product/product.redux';
import { reducer as subscriptionReducer } from './subscription/subscription.redux';
import { reducer as ecommerceOrderReducer } from './ecommerceOrder/ecommerceOrder.redux';
import { reducer as ctrlCredentialsReducer } from './ctrlcredentials/credentials.redux';
import { reducer as couponReducer } from './coupon/coupon.redux';

export default combineReducers({
  auth: authReducer,
  reports: reportsReducer,
  visits: visitsReducer,
  consultationsQueue: consultationsQueueReducer,
  patients: patientsReducer,
  practitioners: practitionersReducer,
  orders: ordersReducer,
  transactions: transactionsReducer,
  states: statesReducer,
  settings: settingsReducer,
  productVariations: productVariationsReducer,
  products: productsReducer,
  projects: projectsReducer,
  affiliateAdmins: affiliateAdminsReducer,
  webhooks: webhooksReducer,
  questionnaires: questionnairesReducer,
  pharmacies: pharmaciesReducer,
  communicationTemplates: communicationTemplatesReducer,
  labOrders: labOrdersReducer,
  labPanels: labPanelsReducer,
  labs: labsReducer,
  noteTemplates: noteTemplatesReducer,
  chat: chatReducer,
  supplies: suppliesReducer,
  tags: tagsReducer,
  journeyTemplate: journeyTemplateReducer,
  product: productReducer,
  subscription: subscriptionReducer,
  ecommerceOrder: ecommerceOrderReducer,
  ctrlCredentials: ctrlCredentialsReducer,
  coupon: couponReducer
});
